module.exports = {
  DEBUG: process.env.NODE_ENV === 'development',

  siteName: 'Capex Tax',
  author: 'zeiq.co',
  description: 'Leading tax & grant consultant specialists',
  siteUrl: 'https://capextax.netlify.app',
  logo: '/images/logo.png',
  metaLogo: '/images/meta-icon.png',

  telephone: '9876543210',
  email: 'capextax.co.uk',
  address: 'Uk,London',
  twitter: 'https://twitter.com',
  facebook: 'https://www.facebook.com',
  instagram: 'https://www.instagram.com',

  type: 'website',
  googleAnalytics: 'U-1',
  backgroundColor: '#FFFFFF',
  themeColor: '#F4892F',
  sanityId: '9hs16qve',
  dataset: 'production',
  apiUrl: 'https://capextax-api.vercel.app/api/graphql',

  mailchimp:
    'https://capextax.us20.list-manage.com/subscribe/post?u=1280bd2917d36ae5c21715c01&amp;id=8c7566e217',
};
